import { useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight, BookOpen, Sparkles } from "lucide-react";
import { Reveal } from "@/components/marketing/kit";
import { ARTICLES } from "@/components/marketing/content";

const CATS = ["All", ...Array.from(new Set(ARTICLES.map((a) => a.category)))];

export default function Resources() {
  const nav = useNavigate();
  const [cat, setCat] = useState("All");
  const [feat, ...rest] = ARTICLES;
  const list = useMemo(() => (cat === "All" ? rest : ARTICLES.filter((a) => a.category === cat)), [cat, rest]);
  return (
    <main>
      <section className="mk-sec" style={{ paddingBottom: 30 }}><div className="mk-wrap mk-head">
        <Reveal><span className="mk-pill"><BookOpen size={14} /> Resources</span></Reveal>
        <Reveal delay={0.08}><h1 className="mk-h2" style={{ fontSize: "clamp(32px,4.6vw,56px)" }} data-testid="resources-title">The creator marketing playbook</h1></Reveal>
        <Reveal delay={0.16}><p data-testid="resources-description">Strategy, AI, analytics and operations — practical guides to run creator campaigns that perform.</p></Reveal>
      </div></section>

      <section className="mk-sec" style={{ paddingTop: 0 }}><div className="mk-wrap">
        <div className="mk-res-cats" data-testid="resource-categories">
          {CATS.map((c) => <button key={c} className={`mk-res-cat${cat === c ? " on" : ""}`} onClick={() => setCat(c)} data-testid={`resource-cat-${c.toLowerCase()}`}>{c}</button>)}
        </div>

        {cat === "All" && (
          <Reveal><div className="mk-res-feature" data-testid="resource-featured" style={{ cursor: "pointer" }} onClick={() => nav(`/resources/${feat.slug}`)}>
            <div className="mk-res-feature-img"><img src={`${feat.cover}&w=900`} alt={feat.title} /></div>
            <div className="mk-res-feature-body">
              <div className="mk-res-meta"><span className="cat">{feat.category}</span><span className="read">{feat.read} read</span></div>
              <h2>{feat.title}</h2>
              <p>{feat.excerpt}</p>
              <Link to={`/resources/${feat.slug}`} className="mk-btn primary" style={{ width: "max-content" }} data-testid="resource-featured-read">Read article <ArrowRight size={16} /></Link>
            </div>
          </div></Reveal>
        )}

        <div className="mk-res-grid">
          {list.map((a, i) => (
            <Reveal key={a.slug} delay={(i % 3) * 0.07}>
              <article className="mk-res-card" data-testid={`resource-card-${a.slug}`} onClick={() => nav(`/resources/${a.slug}`)}>
                <div className="mk-res-card-img"><img src={`${a.cover}&w=600`} alt={a.title} /></div>
                <div className="mk-res-card-body">
                  <div className="mk-res-meta"><span className="cat">{a.category}</span><span className="read">{a.read} read</span></div>
                  <h3>{a.title}</h3>
                  <p>{a.excerpt}</p>
                  <span className="more">Read more <ArrowRight size={14} /></span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div></section>

      <section className="mk-sec" style={{ paddingTop: 0 }}><div className="mk-wrap"><div className="mk-cta">
        <span className="mk-pill" style={{ margin: "0 auto" }}><Sparkles size={14} /> Put it into practice</span>
        <h2>Stop reading, start shipping</h2>
        <div className="mk-cta-actions"><Link to="/login?mode=register" className="mk-btn primary lg" data-testid="resources-final-trial">Start free <ArrowRight size={17} /></Link></div>
      </div></div></section>
    </main>
  );
}
